export const data = {
  buttons: [
    { label: 'Online (from a company)', id: 'online' },
    { label: 'In store', id: 'inStore' },
    { label: 'Private seller', id: 'privateSeller' },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/72a9e3b8be74-tooliconlaptop.jpg',
  },
  title: 'Where did you buy the item?',
}
